export enum InvoiceStatus {
  New = 'NEW',
  Failed = 'FAILED',
  Generated = 'GENERATED',
}
